import { Button } from 'Components/Core';
import { IconSettings } from 'Lib/Icons';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { WorksheetBalanceConfigurationDialog } from '.';

/**
 * Component that provides a button to configure the default balance configuration for bulk entry
 * and controls the display of the associated dialog
 */
const WorksheetBalanceConfigurationDialogButton: React.FC = () => {
  const [showDialog, setShowDialog] = useState<boolean>();

  const disabled = useSelector((state) => state.worksheetGrid.status.refreshing);

  return (
    <>
      <WorksheetBalanceConfigurationDialog visible={showDialog} onClose={() => setShowDialog(false)} />
      <Button subtle onClick={() => setShowDialog(true)} disabled={disabled}>
        <IconSettings size={'1.75em'} />
      </Button>
    </>
  );
};

export { WorksheetBalanceConfigurationDialogButton };
export default WorksheetBalanceConfigurationDialogButton;
